import { SingleTableBoxScene } from "@/shared/components/ui";
import TableRegistroFacturas from "../../components/table-registro-facturas/TableRegistroFacturas";
import { ROUTER_PATHS, useCheckPermissions} from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";


export default function RegistrFacturas() {
  useCheckPermissions(PermissionsEnum.api_view_facturaordencompragasto)

  return (
    <SingleTableBoxScene
      title="Registro de Facturas"
      urlRedirect={`${ROUTER_PATHS.contabilidad.registroFacturaNav}/CREAR`}
    >
      <TableRegistroFacturas />
    </SingleTableBoxScene>
  )
}